import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { CheckItem } from './ui/CheckItem';
import { FULL_MOCKUP_URL } from '../data/images';
import { valueStackItems } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function ValueStack() {
  return <section className="bg-mp-dark py-20 md:py-28" data-id="element-377" data-mp="2i02dcvc049gb">
      <Container data-id="element-378" data-mp="2myc7r3pwj60v">
        <div className="flex flex-col items-center gap-12 md:flex-row md:items-center md:gap-16" data-id="element-379" data-mp="2myvkm60p3481">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          ease: easeOut
        }} className="w-full md:w-[45%]" data-id="element-380" data-mp="2980day5ugv6k">
            <div className="relative" data-id="element-381" data-mp="35pmy9jrptgs8">
              <div className="pointer-events-none absolute inset-0 -z-10 rounded-full opacity-60 blur-2xl" style={{
              background: 'radial-gradient(circle, rgba(216,240,0,0.18), transparent 70%)'
            }} aria-hidden="true" data-id="element-382" data-mp="35qob9tsakdcl" />
              <img src={FULL_MOCKUP_URL} alt="Todo lo que incluye Maestro en Pista" width={700} height={700} loading="lazy" className="mx-auto w-full max-w-[480px]" data-id="element-383" data-mp="2367v50yoo3xz" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          ease: easeOut,
          delay: 0.05
        }} className="w-full md:w-[55%]" data-id="element-384" data-mp="283pv41uq38tu">
            <SectionTag tone="lime" data-id="element-385" data-mp="rqspl8ses3r9">Esto es lo que desbloqueas hoy</SectionTag>
            <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-386" data-mp="mrpuoh657dx0">
              Tu nuevo sistema de trabajo en pista.
            </h2>

            <ul className="mt-7 space-y-3" data-id="element-387" data-mp="2rrz7wma75zt8">
              {valueStackItems.map(item => <CheckItem key={item} data-id="element-388" data-mp="2vtu9lrw1if7j">{item}</CheckItem>)}
            </ul>

            <p className="mt-6 font-heading text-xs uppercase tracking-[0.18em] text-mp-electric" data-id="element-389" data-mp="2vw6yyq44nrum">
              5 Tomos + 5 Bonos
            </p>

            <div className="mt-6 rounded-2xl border border-mp-border bg-mp-card p-6" data-id="element-390" data-mp="35qyzo2t0autm">
              <p className="font-heading text-4xl text-mp-lime sm:text-5xl" data-id="element-391" data-mp="3aqbhg950tbpc">17,90 €</p>
              <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-392" data-mp="3fhbfxitsg1ty">Pago único</p>

              <CTAButton href="#oferta" className="mt-5 w-full" showArrow data-id="element-393" data-mp="3jjyee2kysl04">
                Quiero Maestro en Pista
              </CTAButton>

              <p className="mt-4 text-center text-xs text-mp-gray sm:text-sm" data-id="element-394" data-mp="3okcmfkmkfuy5">
                ✓ Acceso inmediato &nbsp; ✓ Producto digital &nbsp; ✓ Consulta desde cualquier dispositivo
              </p>
            </div>
          </motion.div>
        </div>
      </Container>
    </section>;
}